import { Activity, Clock, Cpu, Tag, Zap } from 'lucide-react';
import { IconBox, Stat } from '@/ui/primitives';
import { GridAuto } from '@/ui/layout';
import type { Health } from '../schemas';

interface Props {
  health: Health | undefined;
  isLoading: boolean;
}

function formatUptime(seconds: number): string {
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export function HealthStats({ health, isLoading }: Props) {
  return (
    <GridAuto min="sm" gap="md">
      <Stat
        label="Versão"
        value={isLoading ? '…' : (health?.hub_version ?? '—')}
        icon={
          <IconBox tone="accent">
            <Tag size={16} strokeWidth={1.5} />
          </IconBox>
        }
      />
      <Stat
        label="Uptime"
        value={isLoading ? '…' : health ? formatUptime(health.uptime_s) : '—'}
        icon={
          <IconBox tone="ok">
            <Clock size={16} strokeWidth={1.5} />
          </IconBox>
        }
      />
      <Stat
        label="Requests"
        value={isLoading ? '…' : (health?.requests.toLocaleString('pt-BR') ?? '—')}
        hint={health ? `${health.errors} erros` : undefined}
        icon={
          <IconBox tone="info">
            <Activity size={16} strokeWidth={1.5} />
          </IconBox>
        }
      />
      <Stat
        label="Memória RSS"
        value={isLoading ? '…' : health ? `${health.mem_rss_mb} MB` : '—'}
        hint={health ? `Heap ${health.mem_heap_mb} MB` : undefined}
        icon={
          <IconBox tone="warn">
            <Cpu size={16} strokeWidth={1.5} />
          </IconBox>
        }
      />
      <Stat
        label="Latência p95"
        value={isLoading ? '…' : health ? `${health.latency_p95_ms} ms` : '—'}
        hint={health ? `p99 ${health.latency_p99_ms} ms` : undefined}
        icon={
          <IconBox tone="accent">
            <Zap size={16} strokeWidth={1.5} />
          </IconBox>
        }
      />
    </GridAuto>
  );
}
